module.exports = __webpack_public_path__ + "static/media/yan.03b868b6.jpg";